(function () {
  function parseJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return fallback;
    }
  }

  function setActiveTab(root, target) {
    var tabs = root.querySelectorAll('[data-tab-target]');
    var panels = root.querySelectorAll('[data-tab-content]');

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-tab-target') === target;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-tab-content') === target;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-tab-target]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(root, tab.getAttribute('data-tab-target'));
      });
    });

    setActiveTab(root, tabs[0].getAttribute('data-tab-target'));
  }

  function initVariantControls(root, selectMedia) {
    var variantsNode = root.querySelector('[data-product-variants]');
    var selectedOptionsNode = root.querySelector('[data-selected-options]');
    var priceMapNode = root.querySelector('[data-variant-price-map]');
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var productPrice = root.querySelector('[data-product-price]');
    var addToCartButton = root.querySelector('[data-add-to-cart-button]');
    var optionButtons = root.querySelectorAll('[data-option-index][data-option-value]');
    var selectedValueNodes = root.querySelectorAll('[data-selected-value][data-option-index]');
    var isPreOrder = root.getAttribute('data-preorder') === 'true';

    if (!variantsNode || !variantIdInput || !optionButtons.length) return;

    var variants = parseJSON(variantsNode.textContent, []);
    var selectedOptions = parseJSON(selectedOptionsNode ? selectedOptionsNode.textContent : '[]', []);
    var variantPriceMap = parseJSON(priceMapNode ? priceMapNode.textContent : '{}', {});

    if (!Array.isArray(variants) || !variants.length) return;

    if (!Array.isArray(selectedOptions)) {
      selectedOptions = [];
    }

    var optionCount = Array.isArray(variants[0].options) ? variants[0].options.length : 0;

    function isVariantAvailable(variant) {
      var mappedVariant = variantPriceMap[String(variant.id)];
      return mappedVariant && typeof mappedVariant.available === 'boolean'
        ? mappedVariant.available
        : Boolean(variant.available);
    }

    function findMatchingVariant() {
      return variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.every(function (optionValue, optionIndex) {
          return selectedOptions[optionIndex] === optionValue;
        });
      });
    }

    function syncOptionUI() {
      optionButtons.forEach(function (button) {
        var optionIndex = Number(button.getAttribute('data-option-index'));
        var optionValue = button.getAttribute('data-option-value');
        var isActive = selectedOptions[optionIndex] === optionValue;
        var isAvailable = variants.some(function (variant) {
          return isVariantAvailable(variant) && variant.options.every(function (value, index) {
            if (index === optionIndex) return value === optionValue;
            return !selectedOptions[index] || selectedOptions[index] === value;
          });
        });
        var optionLabel = button.getAttribute('data-option-label') || button.getAttribute('aria-label') || optionValue;
        var soldOutLabel = addToCartButton ? addToCartButton.getAttribute('data-sold-out-label') : null;
        button.setAttribute('data-option-label', optionLabel);
        button.classList.toggle('is-active', isActive);
        button.classList.toggle('is-unavailable', !isAvailable);
        button.setAttribute('aria-pressed', String(isActive));
        // Sold-out choices remain selectable so their assigned photo can be viewed.
        button.setAttribute('aria-label', isAvailable ? optionLabel : optionLabel + ' — ' + (soldOutLabel || 'SOLD OUT'));
      });

      selectedValueNodes.forEach(function (selectedValueNode) {
        var optionIndex = Number(selectedValueNode.getAttribute('data-option-index'));
        var selectedValue = selectedOptions[optionIndex];
        if (selectedValue) {
          // Hex-coded swatch values (e.g. "#E9D54A #7FB6C9") render as the
          // colour circle only — don't surface the raw hex string as a label.
          selectedValueNode.textContent = selectedValue.indexOf('#') !== -1 ? '' : selectedValue;
        }
      });
    }

    function allOptionsSelected() {
      if (optionCount === 0) return true;
      if (selectedOptions.length < optionCount) return false;
      for (var i = 0; i < optionCount; i++) {
        if (selectedOptions[i] == null || selectedOptions[i] === '') return false;
      }
      return true;
    }

    function syncVariantState(variant, revealMedia) {
      var fullySelected = allOptionsSelected();

      if (!variant || !fullySelected) {
        if (addToCartButton && !isPreOrder) {
          addToCartButton.disabled = true;
          addToCartButton.setAttribute('aria-disabled', 'true');
          addToCartButton.classList.add('is-disabled');
          addToCartButton.textContent =
            addToCartButton.getAttribute('data-select-options-label') || 'SELECT OPTIONS';
        }
        return;
      }

      variantIdInput.value = variant.id;
      if (selectMedia) {
        selectMedia(variant.featured_media ? variant.featured_media.id : null, revealMedia);
      }

      if (productPrice) {
        var mappedPrice = variantPriceMap[String(variant.id)] && variantPriceMap[String(variant.id)].price;
        if (mappedPrice) {
          productPrice.textContent = mappedPrice;
        }
      }

      if (addToCartButton && !isPreOrder) {
        addToCartButton.classList.remove('is-disabled');
        var defaultLabel = addToCartButton.getAttribute('data-default-label') || 'ADD TO CART';
        var soldOutLabel = addToCartButton.getAttribute('data-sold-out-label') || 'SOLD OUT';
        var isSoldOut = !isVariantAvailable(variant);

        addToCartButton.disabled = isSoldOut;
        addToCartButton.setAttribute('aria-disabled', String(isSoldOut));
        addToCartButton.textContent = isSoldOut ? soldOutLabel : defaultLabel;
      }
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var optionIndex = Number(button.getAttribute('data-option-index'));
        var optionValue = button.getAttribute('data-option-value');
        selectedOptions[optionIndex] = optionValue;
        syncOptionUI();
        syncVariantState(findMatchingVariant(), true);
      });
    });

    syncOptionUI();
    syncVariantState(findMatchingVariant());

    if (isPreOrder) {
      initPreorder(root, selectedOptions, variants, variantPriceMap);
    }
  }

  function initPreorder(root, selectedOptions, variants, variantPriceMap) {
    var section = root.closest('[id^="shopify-section-"]') || root.parentElement;
    var overlay = section.querySelector('[data-preorder-overlay]');
    var openBtn = root.querySelector('[data-preorder-open]');
    if (!overlay || !openBtn) return;

    var modal = overlay.querySelector('[data-preorder-modal]');
    var qtyVal = overlay.querySelector('[data-preorder-qty-val]');
    var minusBtn = overlay.querySelector('[data-preorder-qty-minus]');
    var plusBtn = overlay.querySelector('[data-preorder-qty-plus]');
    var bodyInput = overlay.querySelector('[data-preorder-body]');
    var form = overlay.querySelector('form');
    var successEl = overlay.querySelector('[data-preorder-success]');
    var qty = 1;

    function openModal() {
      overlay.classList.add('is-open');
    }

    function closeModal() {
      overlay.classList.remove('is-open');
    }

    openBtn.addEventListener('click', openModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    section.querySelectorAll('[data-preorder-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
    });

    if (minusBtn && plusBtn && qtyVal) {
      minusBtn.addEventListener('click', function () {
        if (qty > 1) {
          qty--;
          qtyVal.textContent = qty;
        }
      });
      plusBtn.addEventListener('click', function () {
        qty++;
        qtyVal.textContent = qty;
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        sessionStorage.setItem('garaia_preorder_submitted', '1');

        var title = root.querySelector('.a-garaia-product-page__title');
        var price = root.querySelector('[data-product-price]');
        var parts = [];
        if (title) parts.push('Product: ' + title.textContent.trim());
        if (selectedOptions.length) parts.push('Variant: ' + selectedOptions.join(' / '));
        if (price) parts.push('Price: ' + price.textContent.trim());
        parts.push('Quantity: ' + qty);
        if (bodyInput) bodyInput.value = parts.join('\n');
      });
    }

    if (sessionStorage.getItem('garaia_preorder_submitted') === '1') {
      sessionStorage.removeItem('garaia_preorder_submitted');
      openModal();
      if (form) form.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
    }
  }

  function initProductGallery(root) {
    var mq = window.matchMedia('(max-width: 768px)');
    var gallery = root.querySelector('.a-garaia-product-page__gallery');
    var dotsContainer = root.closest('.a-garaia-product-page-section')
      ? root.closest('.a-garaia-product-page-section').querySelector('.agpp-mobile-dots')
      : null;
    if (!dotsContainer) {
      var layout = root.querySelector('.a-garaia-product-page__layout');
      if (layout) dotsContainer = layout.querySelector('.agpp-mobile-dots');
    }
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.agpp-mobile-dot') : [];
    var section = root.closest('[id^="shopify-section-"]') || root.parentElement;
    var fullscreen = section ? section.querySelector('[data-agpp-fullscreen]') : null;
    var fullscreenBody = fullscreen ? fullscreen.querySelector('[data-agpp-fullscreen-body]') : null;
    var fullscreenClose = fullscreen ? fullscreen.querySelector('[data-agpp-fullscreen-close]') : null;
    var mediaItems = gallery ? gallery.querySelectorAll('.a-garaia-product-page__media') : [];
    var variantsNode = root.querySelector('[data-product-variants]');
    var variants = parseJSON(variantsNode ? variantsNode.textContent : '[]', []);
    if (!Array.isArray(variants)) variants = [];
    var variantMediaIds = variants.map(function (variant) {
      return variant.featured_media ? String(variant.featured_media.id) : null;
    }).filter(Boolean);
    var scrollTimer = null;

    if (!gallery || !mediaItems.length) return;

    function updateDots(index) {
      var count = gallery.querySelectorAll('.a-garaia-product-page__media:not([hidden])').length;
      dots.forEach(function (dot, i) {
        dot.hidden = i >= count;
        dot.classList.toggle('agpp-mobile-dot--active', i < count && i === index);
      });
      if (dotsContainer) dotsContainer.hidden = count <= 1;
    }

    function getCurrentIndex() {
      var w = gallery.offsetWidth;
      if (w === 0) return 0;
      return Math.round(gallery.scrollLeft / w);
    }

    function onGalleryScroll() {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(function () {
        updateDots(getCurrentIndex());
      });
    }

    function openFullscreen(startIndex) {
      if (!fullscreen || !fullscreenBody) return;
      fullscreenBody.innerHTML = '';

      var images = gallery.querySelectorAll('.a-garaia-product-page__media:not([hidden]) .a-garaia-product-page__img');
      images.forEach(function (img) {
        var clone = img.cloneNode(true);
        clone.removeAttribute('loading');
        clone.style.position = 'static';
        clone.style.width = '100%';
        clone.style.height = 'auto';
        fullscreenBody.appendChild(clone);
      });

      fullscreen.classList.add('is-open');
      fullscreen.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        // A short final photo needs enough trailing space to align at the top
        // when opened, rather than stopping at the gallery's maximum scroll.
        var lastImage = fullscreenBody.lastElementChild;
        fullscreenBody.style.paddingBottom = lastImage
          ? Math.max(0, fullscreen.clientHeight - lastImage.getBoundingClientRect().height) + 'px'
          : '';
        var targetImg = fullscreenBody.children[startIndex || 0];
        fullscreen.scrollTop = targetImg ? targetImg.offsetTop : 0;
      });
    }

    function closeFullscreen() {
      if (!fullscreen) return;
      fullscreen.classList.remove('is-open');
      fullscreen.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function onMediaTap(e) {
      if (!mq.matches) return;
      var media = e.currentTarget;
      if (media.getAttribute('data-media-type') !== 'image') return;
      var idx = Number(media.getAttribute('data-image-index')) || 0;
      openFullscreen(idx);
    }

    function selectMedia(mediaId, revealMedia) {
      var target = mediaId ? gallery.querySelector('[data-media-id="' + mediaId + '"]') : null;
      if (mediaId && !target) return;

      // Show the chosen variant and shared media (such as packaging), keeping
      // the other variants in the DOM for the next selection, not in the gallery.
      mediaItems.forEach(function (item) {
        var isVariantMedia = variantMediaIds.indexOf(item.getAttribute('data-media-id')) !== -1;
        item.hidden = Boolean(target && isVariantMedia && item !== target);
      });
      if (target) {
        if (gallery.firstElementChild !== target) gallery.prepend(target);
      } else {
        // Variants without an assigned photo retain the complete product gallery.
        mediaItems.forEach(function (item) { gallery.appendChild(item); });
      }
      var image = target ? target.querySelector('.a-garaia-product-page__img') : null;
      if (image) image.loading = 'eager';
      gallery.querySelectorAll('.a-garaia-product-page__media--image:not([hidden])').forEach(function (item, index) {
        item.setAttribute('data-image-index', String(index));
      });
      gallery.querySelectorAll('video').forEach(function (video) { video.pause(); });
      gallery.scrollTo({ left: 0, behavior: 'instant' });
      updateDots(0);

      var rect = target ? target.getBoundingClientRect() : null;
      if (revealMedia && rect && (rect.top < 0 || rect.top > window.innerHeight)) {
        target.scrollIntoView({
          block: 'start',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }

    function attachListeners() {
      gallery.addEventListener('scroll', onGalleryScroll, { passive: true });

      mediaItems.forEach(function (item) {
        if (item.getAttribute('data-media-type') !== 'image') return;
        item.addEventListener('click', onMediaTap);
        item.style.cursor = 'pointer';
      });

      if (fullscreenClose) {
        fullscreenClose.addEventListener('click', closeFullscreen);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && fullscreen && fullscreen.classList.contains('is-open')) {
          closeFullscreen();
        }
      });
    }

    function onMatchChange() {
      if (mq.matches) {
        updateDots(getCurrentIndex());
      }
    }

    attachListeners();
    if (mq.addEventListener) {
      mq.addEventListener('change', onMatchChange);
    } else if (mq.addListener) {
      mq.addListener(onMatchChange);
    }
    if (mq.matches) {
      updateDots(0);
    }
    return selectMedia;
  }

  function initVideoFullscreen(root) {
    var fullscreenButtons = root.querySelectorAll('[data-agpp-video-fullscreen]');

    fullscreenButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var media = button.closest('.a-garaia-product-page__media');
        var video = media ? media.querySelector('video') : null;
        if (!video) return;

        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });
    });
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.agppInitialized === 'true') return;
    sectionRoot.dataset.agppInitialized = 'true';
    initTabs(sectionRoot);
    var selectMedia = initProductGallery(sectionRoot);
    initVariantControls(sectionRoot, selectMedia);
    initVideoFullscreen(sectionRoot);
  }

  function initAll(scope) {
    var roots = scope.querySelectorAll('.a-garaia-product-page[data-section-id]');
    roots.forEach(function (root) {
      initSection(root);
    });
  }

  function onReady() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionContainer = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!sectionContainer) return;
    initAll(sectionContainer);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionContainer = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!sectionContainer) return;
    var roots = sectionContainer.querySelectorAll('.a-garaia-product-page[data-section-id]');
    roots.forEach(function (root) {
      delete root.dataset.agppInitialized;
    });
  });
})();
